export default "__VITE_ASSET__6H0J8E6p__"